import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountCallsTimeSeriesItemAggregateRootMapper } from '../../../../infrastructure/mappers/org-metrics/calls/account-calls-time-series-Item.aggregate-root.mapper';
import { GetAccountCallEventsTimeSeriesRequestDto } from '../../../dtos/org-metrics/calls/get-account-call-events-time-series.request.dto';
import { GetAccountCallEventsTimeSeriesResponseDto } from '../../../dtos/org-metrics/calls/get-account-call-events-time-series.response.dto';
import { GetAccountCallEventsTimeSeriesQuery } from '../../../queries/org-metrics/calls/get-account-call-events-time-series.query';

export class GetAccountCallEventsTimeSeriesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountCallEventsTimeSeriesQuery,
    protected readonly mapper: AccountCallsTimeSeriesItemAggregateRootMapper
  ) {}

  async get(
    props: GetAccountCallEventsTimeSeriesRequestDto
  ): Promise<GetAccountCallEventsTimeSeriesResponseDto[]> {
    try {
      const result = await this.query.execute(props);

      return result.map((entity) => {
        return this.mapper.toResponse(entity);
      });
    } catch (error) {
      throw new Error(
        `GetAccountCallEventsTimeSeriesController.get encountered an error ${error}`
      );
    }
  }
}
